const lang = {
    ja: {
        'livestream.watchLivestream': 'ライブ配信を見る',
        'livestream.oneDayLimitPayment': 'クレジットでのお支払い方法は、催しの開催日の1時間前までに限ります。',
        'livestream.threeDayLimitPayment': '銀行振込でのお支払い方法は、催しの開催日の3日前までに限ります。 別のお支払い方法を選択してください',
        'livestream.register': 'これらの{namePage}をお申込みしますか？',
        'livestream.registerNext': 'これらの{namePage}をお申込みします？',
        'livestream.noViewLivestream': `{namePage}のURLがまだありませんので、この{namePage}を見ることができません。
                        見るために、管理者にお問い合わせをください。`,
        'livestream.deliveryTime': '配信時間',
        'livestream.deliveryContent': '配信内容',
        'livestream.apply': '申込む',
        'livestream.waitingTime': '{namePage}時間に至らないので、お待ちください。',
        'livestream.notePaymentProcedure': '{namePage}を視聴したい場合、支払い手続きを完了してください。',
        'livestream.watch': '視聴',
        'livestream.viewDetail': '講演内容を詳しく見る',
        'livestream.performerProfile': '出演者プロフィール',
    },
    en: {
        'livestream.watchLivestream': 'Watch live streaming',
        'livestream.oneDayLimitPayment': 'Credit card payment is not acceptable when the event starts in less than an hour.',
        'livestream.threeDayLimitPayment': 'Bank transfer payment is not acceptable when the event starts in less than three days. Please select another payment method.',
        'livestream.register': 'Are you sure you want to apply for this {namePage}?',
        'livestream.registerNext': 'Are you sure you want to apply for this {namePage}?',
        'livestream.noViewLivestream': `You cannot watch this live streaming as URL has not been assigned to it. 
                                    Please contact the administrator for watching it.`,
        'livestream.deliveryTime': 'Streaming start time',
        'livestream.deliveryContent': 'Streaming content',
        'livestream.apply': 'Apply',
        'livestream.waitingTime': 'Please wait until the {namePage} starts.',
        'livestream.notePaymentProcedure': 'If you want to watch {namePage}, please complete payment.',
        'livestream.watch': 'Watch',
        'livestream.viewDetail': 'View the details of the live stream',
        'livestream.performerProfile': 'Performer profile',
    },
};

export default lang;
